// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwSplmTable from 'viewmodel/AwSplmTableViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));
registerDynImportEntry('js/desUpdateLibraryService', () => import('js/desUpdateLibraryService'));
registerDynImportEntry('js/DesListLibraryContentService', () => import('js/DesListLibraryContentService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "imports": [],
    "data": {
        "pageSize": 50,
        "nodeBeingExpandedName": "",
        "isParent": false,
        "selectedNodeUrn": "",
        "isRenderListComponentOnMount": true
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "libraryid": {
            "type": "string"
        },
        "collaborationspaceid": {
            "type": "string"
        },
        "containerid": {
            "type": "string"
        },
        "folderid": {
            "type": "string"
        }
    },
    "lifecycleHooks": {},
    "actions": {
        "fetchLibraryContentDetails": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationspaceid": "{{props.collaborationspaceid}}",
                            "parentNodeUid": "{{data.treeLoadInput.parentNode.uid}}",
                            "parentNodeLevelNdx": "{{data.treeLoadInput.parentNode.levelNdx}}",
                            "isParent": "{{data.data.isParent}}",
                            "nodeBeingExpandedName": "{{data.data.nodeBeingExpandedName}}",
                            "selectedNodeUrn": "{{data.data.selectedNodeUrn}}",
                            "selectedNodeTypeName": "{{data.data.selectedNodeTypeName}}",
                            "selectedNodeId": "{{data.data.selectedNodeId}}",
                            "isSelectedNodeIsFolder": "{{data.data.isFolder}}",
                            "isRenderListComponentOnMount": "{{data.data.isRenderListComponentOnMount}}"
                        },
                        "query": "query ListLibraryContent( $containerId: String, $folderId: String, $collaborationspaceId: String, $searchOptionsInput: SearchOptionsInput ) {listLibraryContent( containerId: $containerId, folderId: $folderId, collaborationspaceId: $collaborationspaceId, searchOptionsInput: $searchOptionsInput) }",
                        "variables": {
                            "containerId": "{{props.libraryid}}",
                            "searchOptionsInput": {
                                "limit": "{{data.pageSize}}",
                                "skip": "{{function:getSkip}}",
                                "outputProperties": [
                                    "*"
                                ]
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "libraryContentDetailsFetched": "data.data.listLibraryContent.libraryObjs",
                "libraryContentTreeLoadResult": "{{function:loadTreeTableData}}"
            },
            "events": {
                "success": [
                    {
                        "name": "listLibraryContentSuccess",
                        "eventData": {
                            "eventName": "listLibraryContentSuccess",
                            "eventData": "{{libraryContentDetailsFetched}}"
                        }
                    },
                    {
                        "name": "libraryComponentsTree.autoSelectFirst"
                    }
                ],
                "failure": [
                    {
                        "name": "listLibraryContentFailure",
                        "eventData": {
                            "eventName": "listLibraryContentFailure",
                            "eventData": "{{libraryContentDetailsNotFetched}}"
                        }
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "performBatchActionOnLibrarySelection": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "publishToACCEventBus",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                },
                {
                    "action": "updateLocalVariable",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                }
            ]
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        },
        "updateLocalVariable": {
            "actionType": "JSFunction",
            "method": "updateVmoVariables",
            "inputData": {
                "data": "{{data}}",
                "keysToUpdate": {
                    "selectedLibraries": "{{parameters.eventData}}"
                }
            },
            "deps": "js/desUpdateLibraryService"
        },
        "setUrnOfLibraryComponent": {
            "actionType": "JSFunction",
            "method": "setUrnOfLibraryComponent",
            "inputData": {
                "vmo": "{{data}}",
                "selectedNodeData": "{{parameters.eventData}}"
            },
            "deps": "js/DesListLibraryContentService"
        },
        "setFirstLibraryComponentSelection": {
            "actionType": "JSFunction",
            "method": "setFirstLibraryComponentSelection",
            "inputData": {
                "data": "{{data}}"
            },
            "deps": "js/DesListLibraryContentService"
        }
    },
    "functions": {
        "loadTreeTableData": {
            "functionName": "loadTreeTableData",
            "parameters": [
                "{{data.treeLoadInput.parentNode}}",
                "{{data.dataProviders.libraryContentTreeDataProvider}}",
                "{{data.pageSize}}"
            ],
            "deps": "js/DesListLibraryContentService"
        },
        "getSkip": {
            "functionName": "getSkip",
            "parameters": [
                "{{data.treeLoadInput.parentNode}}"
            ],
            "deps": "js/DesListLibraryContentService"
        }
    },
    "dataProviders": {
        "libraryContentTreeDataProvider": {
            "action": "fetchLibraryContentDetails",
            "initializeAction": "fetchLibraryContentDetails",
            "treeLoadResult": "{{data.libraryContentTreeLoadResult}}",
            "totalFound": "{{data.libraryContentTreeLoadResult.totalChildCount}}",
            "inputData": {
                "accessMode": "tree",
                "topNodeUid": "libraryContent"
            },
            "selectionModelmode": "none",
            "cacheCollapse": "TRUE"
        }
    },
    "columnProviders": {
        "libraryContentColumnProvider": {
            "columns": [
                {
                    "name": "name",
                    "displayName": "{{i18n.nameDisplayName}}",
                    "minWidth": 230,
                    "width": 330,
                    "isTreeNavigation": true
                },
                {
                    "name": "type",
                    "displayName": "{{i18n.type}}",
                    "minWidth": 70,
                    "width": 100
                },
                {
                    "name": "description",
                    "displayName": "{{i18n.descriptionDisplayName}}",
                    "minWidth": 170,
                    "width": 210
                }
            ],
            "frozenColumnIndex": -1
        }
    },
    "grids": {
        "treeGridForLibraryContent": {
            "dataProvider": "libraryContentTreeDataProvider",
            "columnProvider": "libraryContentColumnProvider",
            "addIconColumn": false,
            "gridOptions": {
                "enableGridMenu": false,
                "enablePinning": false,
                "enableSorting": false,
                "enableExpansionStateCaching": true
            }
        }
    },
    "onEvent": [
        {
            "eventId": "listLibraryContentSuccess",
            "cacheEventData": true,
            "action": "",
            "inputArgs": {
                "eventName": "listLibraryContentSuccess",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "listLibraryContentFailure",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "listLibraryContentFailure",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "libraryContentTreeDataProvider.selectionChangeEvent",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "des-list-library-content.selectionChange",
                "eventData": "{{eventData.selectedObjects}}"
            }
        },
        {
            "eventId": "treeGridForLibraryContent.plTable.toggleTreeNode",
            "cacheEventData": true,
            "action": "setUrnOfLibraryComponent",
            "inputArgs": {
                "eventName": "treeGridForLibraryContent.plTable.toggleTreeNode",
                "eventData": "{{eventData}}"
            }
        },
        {
            "eventId": "libraryComponentsTree.autoSelectFirst",
            "action": "setFirstLibraryComponentSelection"
        },
        {
            "eventId": "desperfromImportSuccess",
            "action": "reveal",
            "inputArgs": {}
        },
        {
            "eventId": "createLibraryFolderSuccess",
            "action": "reveal",
            "inputArgs": {}
        }
    ],
    "conditions": {},
    "i18n": {
        "nameDisplayName": [
            "DesLibraryMessages"
        ],
        "descriptionDisplayName": [
            "DesLibraryMessages"
        ],
        "type": [
            "DesLibraryMessages"
        ]
    },
    "_viewModelId": "DesListLibraryContent",
    "_uniqueViewModelId": "DesListLibraryContent",
    "ctx": {}
};

    /*
    <div class="des-List-Library-Content des-List-Library-Content-Style" style="height:100%; margin: 5px;">
    <aw-panel-body>
        <aw-splm-table gridid="treeGridForLibraryContent" use-tree="true" show-decorators="true"></aw-splm-table>
    </aw-panel-body>
    </aw-panel>
</div>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <div className="des-List-Library-Content des-List-Library-Content-Style" style={{height: '100%', margin: '5px'}}>
        <AwPanelBody>
            <AwSplmTable {...grids.treeGridForLibraryContent} useTree={AwParseService.instance( "true" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} showDecorators={AwParseService.instance( "true" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
            </AwSplmTable>
        </AwPanelBody>
    </div>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;